export default __webpack_public_path__ + "static/media/background-dark-1.33bc77fc.jpg";